define(function (require, exports) {
    'use strict';
    var moment = require('moment');
    var _ = require('lodash');
    // @ngInject
    exports.metroUtils = function ($window, metroMeta, metroContext) {
        return {
            /**
             * Returns index and obj found by key in obj
             * @param obj
             * @param keyName
             * @returns {{index: number, filteredObj: *}}
             */
            findObjByKeyName: function (obj, keyName) {
                var index = -1;
                obj.findIndex(function (e, i) {
                    index = i;
                    return e.key === keyName;
                });

                return { index: index, filteredObj: obj[index] };
            },

            print: function() {
                $window.print();
            },

            canPrint: function() {
                return $window.print;
            },

            /**
             * Retrieves all query params from the url and presents them as an object
             * @returns {Object}
             */
            getQueryParams: function() {
                // remove initial "?"
                var search = window.location.search.substr(1);
                var pairs = search.split('&');

                // compose array of array pairs [[key, value], ...]
                var pairsArrays = pairs.map(function(pair) {
                    if(pair.indexOf("locked") == -1){
                        return pair.split('=');
                    }
                    else {
                        return ["locked", "false"]
                    }
                });

                // convert matrix to object
                return _.zipObject(pairsArrays);
            },
            getTppToggle: function(){
                var tpp=localStorage.getItem('TPP');
                return tpp;
            },
            navigate: function(url, preserveQueryParams) {
                var baseUri = b$.portal.config.serverRoot + '/';
                var search = '';
                if (preserveQueryParams) {
                    search = window.location.search;
                }

                window.location.href = baseUri + url + search;
            },

            findEnvironment: function(){
                var environment=metroMeta.ENVIRONMENT.DEV.isDev;
                var url=window.location.href;
                if(url.indexOf(metroMeta.ENVIRONMENT.PROD.url)!= -1){
                    environment=metroMeta.ENVIRONMENT.PROD.isProd;
                }
                else if(url.indexOf(metroMeta.ENVIRONMENT.STAGING.url)!= -1){
                    environment=metroMeta.ENVIRONMENT.STAGING.isStaging;
                }
                return environment;
            },

            checkAuthLevel: function () {
                var authLvl = '0';
                if (metroContext.hasAnyApprovalLevel()) {
                    authLvl = '1';
                } else if (metroContext.hasAnyVerificationLevel()) {
                    authLvl = '2';
                }
                return authLvl;
            },

            isShadowNostroCurrency: function (currency) {
                var shadowNostroCurrencies = ["ILS", "INR", "KES"];
                return (shadowNostroCurrencies.indexOf(currency) > -1);
            },

            checkForTPlusOneCurrencyPair: function(debitCurrency, creditCurrency){
                var tPlusOnePairs = ['USD/CAD', 'CAD/USD'];
                return (tPlusOnePairs.indexOf(debitCurrency + '/' + creditCurrency) > -1)
            },

            convertMS: function( milliseconds ) {
                var hour, minute, seconds;
                seconds = Math.floor(milliseconds / 1000);
                minute = Math.floor(seconds / 60);
                seconds = seconds % 60;
                hour = Math.floor(minute / 60);
                minute = minute % 60;
                hour = hour % 24;
                return {

                    hour: hour,
                    minute:minute
                };
            },

            isCloseToCutOffTime: function (timezone, cutOffTime) {

                if (!cutOffTime || !timezone) return;

                var closeToCutOffTime = false;


                //Get the offset of timezone for local location
                var zoneOffset = moment().utcOffset() / 60
                var offsetNumber = zoneOffset.toString();

                // calculate the difference between current location and server location

                var serverTimezoneDifference = timezone.slice(4, 6)
                var difference = offsetNumber - serverTimezoneDifference

                //get the current location date

                var d = new Date();
                var n = d.getHours();
                var min = d.getMinutes();

                //add 2 digits to minutes
                if (min < 10) {
                    min = '0' + min;
                } else {
                    min = min + '';
                }

                // adapt current location time to the server cuttof time
                var compareHours = n - difference
                var fullCompareHour = compareHours + ':' + min

                // calculate 5 min before cutOffTime

                var cutOffTimeFormat = cutOffTime.split(':')
                var cutOffTimeFormatMiliseconds = (cutOffTimeFormat[0] * (60000 * 60)) + (cutOffTimeFormat[1] * 60000)
                var cutOffTimeDifference = cutOffTimeFormatMiliseconds - (60000 * 5)
                var startCutOffTimeWarning = this.convertMS(cutOffTimeDifference)
                var timeToInformUser = startCutOffTimeWarning.hour + ":" + startCutOffTimeWarning.minute

                var actualTimeCompare = new Date("01/01/2000 " + fullCompareHour);
                var timeCompare = new Date("01/01/2000 " + timeToInformUser);

                if (actualTimeCompare >= timeCompare){
                   closeToCutOffTime = true
                }else{
                   closeToCutOffTime = false
                }
                return closeToCutOffTime
            },

            
            

            isCutOffTimePassed: function (timezone, cutOffTime, date) {
                
                if (!cutOffTime || !timezone) return;

                //get the UK date

                var milliseconds = date

                var dateServerObject = new Date(milliseconds)
                var serverDate = moment(dateServerObject).format('DD/MM/YYYY');

                //Get the offset of timezone for local location
                // 

                var zoneOffset = moment().utcOffset() / 60

                var offsetNumber = zoneOffset.toString();
 
                // calculate the difference between current location and server location

                var serverTimezoneDifference = timezone.slice(4, 6)
                var difference = offsetNumber - serverTimezoneDifference

                //get the current location date

                var d = new Date();
                var formatDate = moment(d).format('DD/MM/YYYY')

                var n = d.getHours();
                var min = d.getMinutes();

                //add 2 digits to minutes
                if (min < 10) {
                    min = '0' + min;
                } else {
                    min = min + '';
                }

                // adapt current location time to the server cuttof time
                var compareHours = n - difference
                var fullCompareHour = compareHours + ':' + min

                // compare the time1(cutofftime) and time2(local time - difference of timezones)
                var time1 = cutOffTime;
                var time2 = fullCompareHour;

                var time1Date = new Date("01/01/2000 " + time1);
                var time2Date = new Date("01/01/2000 " + time2);

                //it is a posibility to have different date between curent location and server location and we will compare that
                if (formatDate > serverDate) {
                    return true;
                } else {
                    return time1Date <= time2Date
                }
            },

            checkOOH: function (timezone, isHolidayToday, rightNow) {
                if (!isHolidayToday) {
                    if (rightNow.getDay() === 5) {
                        isHolidayToday = this.isCutOffTimePassed(timezone, '21:00');
                    }
                    if (rightNow.getDay() === 1) {
                        isHolidayToday = !this.isCutOffTimePassed(timezone, '02:00');
                    }
                }
                return isHolidayToday;
            },

            parseCurrencyFormat: function (amount) {
                return parseFloat(amount.toString().replace(/[ ,]/g, '').trim());
            },
            getUKTime: function() {
                var now = new Date() 
                var formatter = new Intl.DateTimeFormat("en-GB", {
                    timeZone : "Europe/London",
                    hour : "numeric",
                    minute : "numeric",
                    second : "numeric",
                    hour12 : false
                })
                var parts = formatter.formatToParts(now)
                var getHour  = parts.find(part => part.type === "hour").value.padStart(2,"0")
                var getMinute = parts.find(part => part.type === 'minute').value.padStart(2,"0")
                return getHour + ":" + getMinute
            },
             cutOffTimeMessages: function()  {
               return {
                passed: 'It’s too late for us to process this payment/transfer today.',
                notPassed: function (hour) {
                    return 'You must send the payment by <b>' + moment(hour, ["HH.mm"]).format("hh:mm a") + ' (UK time)</b> for it to be processed today.'
                },
               }
            }
        };
    };
});



// WEBPACK FOOTER //
// ./scripts/services/metroUtils.js